import Footer from 'client/common/components/footer';

import './index.css';

export default Footer;
